import { queryClient } from '@/src/lib/react-query/react-query';
import {
  MY_TASKS_CALENDAR_RQ_KEY,
  MY_TASKS_CATCHUP_RQ_KEY,
  MY_PORTFOLIO_TASKS_CALENDAR_RQ_KEY,
  MY_PORTFOLIO_TASKS_CATCHUP_RQ_KEY,
} from '@/src/components/myTasks2/components/Tabs/MyPortfolio/api/config';

export const invalidateMyTasksCalendar = (selectedWeek?: string) => {
  const queries = queryClient.getQueriesData([MY_TASKS_CALENDAR_RQ_KEY]);
  if (queries.length < 1) return;
  queries.forEach(([queryKey]: any) => {
    const params = queryKey?.[1];
    if (params?.selectedWeekStartDate === selectedWeek) {
      queryClient.invalidateQueries({ queryKey, exact: true });
    }
  });
};

export const invalidateMyTasksCatchup = () => {
  const queries = queryClient.getQueriesData([MY_TASKS_CATCHUP_RQ_KEY]);
  if (queries.length < 1) return;
  const uniqueKeys = new Set<string>();
  queries.forEach(([queryKey]: any) => {
    const keyString = JSON.stringify(queryKey);
    if (!uniqueKeys.has(keyString)) {
      uniqueKeys.add(keyString);
    }
  });
  uniqueKeys.forEach((keyString) => {
    const queryKey = JSON.parse(keyString);
    if (!queryClient.isFetching({ queryKey })) {
      queryClient.removeQueries([MY_TASKS_CATCHUP_RQ_KEY], {
        exact: false,
      });
      queryClient.invalidateQueries({ queryKey, exact: true });
    }
  });
};

export const invalidateMyPortfolioCalendar = (selectedWeek?: string) => {
  const queries = queryClient.getQueriesData([MY_PORTFOLIO_TASKS_CALENDAR_RQ_KEY]);
  if (queries.length < 1) return;
  queries.forEach(([queryKey]: any) => {
    const params = queryKey?.[1];
    if (params?.selectedWeekStartDate === selectedWeek) {
      queryClient.invalidateQueries({ queryKey, exact: true });
    }
  });
};

export const invalidateMyPortfolioCatchup = () => {
  const queries = queryClient.getQueriesData([MY_PORTFOLIO_TASKS_CATCHUP_RQ_KEY]);
  if (queries.length < 1) return;
  const uniqueKeys = new Set<string>();
  queries.forEach(([queryKey]: any) => {
    const keyString = JSON.stringify(queryKey);
    if (!uniqueKeys.has(keyString)) {
      uniqueKeys.add(keyString);
    }
  });
  uniqueKeys.forEach((keyString) => {
    const queryKey = JSON.parse(keyString);
    if (!queryClient.isFetching({ queryKey })) {
      queryClient.removeQueries([MY_PORTFOLIO_TASKS_CATCHUP_RQ_KEY], { exact: false });
      queryClient.invalidateQueries({ queryKey, exact: true });
    }
  });
};

export const invalidateMyTasksDashboard = (queryKey?: any) => {
  queryClient.invalidateQueries({ queryKey: ['tasksList', 'MyTasks'], exact: false });
};
